var map = {
	"./gaoya-1.svg": "5760",
	"./gaoya0.svg": "5ba1",
	"./gaoya1.svg": "57d7",
	"./gaoya10.svg": "dae2",
	"./gaoya65535.svg": "8abd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c77";